// Reloads a long-lived tab / home-screen app when a newer build is live, so clients never run week-old code.
// Careful by design: waits for the new build to be stable, confirms the site answers, and spreads reloads out
// so a publish never knocks every phone onto the offline page at once.
const currentMainJs = () => {
  const s = Array.from(document.scripts).find((x) => /\/static\/js\/main\.[a-z0-9]+\.js$/.test(x.src || ""));
  return s ? new URL(s.src).pathname : null;
};

const liveMainJs = async () => {
  const r = await fetch(`/asset-manifest.json?ts=${Date.now()}`, { cache: "no-store" });
  if (!r.ok) return null;
  return (await r.json())?.files?.["main.js"] || null;
};

const siteAnswers = async () => {
  try {
    const r = await fetch(`/?healthz=${Date.now()}`, { cache: "no-store", method: "HEAD" });
    return r.ok;
  } catch { return false; }
};

export const startFreshnessWatch = ({ intervalMs = 10 * 60 * 1000 } = {}) => {
  const mine = currentMainJs();
  if (!mine) return;
  let checking = false;
  let seen = null;
  const check = async () => {
    if (checking || document.visibilityState !== "visible" || !navigator.onLine) return;
    checking = true;
    try {
      const live = await liveMainJs();
      if (!live || live === mine) { seen = null; return; }
      // same new hash twice, at least 20s apart → the rollout has settled
      if (!seen || seen.hash !== live) { seen = { hash: live, at: Date.now() }; return; }
      if (Date.now() - seen.at < 20000) return;
      if (!(await siteAnswers())) return;
      // never reload while the client is in the middle of something
      if (document.querySelector("[role='dialog']") || document.activeElement?.matches?.("input, textarea, select")) return;
      setTimeout(() => window.location.reload(), Math.random() * 30000);
    } catch { /* offline or blocked — try again later */ }
    finally { checking = false; }
  };
  document.addEventListener("visibilitychange", check);
  window.addEventListener("focus", check);
  setInterval(check, intervalMs);
  setTimeout(check, 45000);
};
